"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PM2 = void 0;
const pm2_1 = __importDefault(require("pm2"));
/**
 * PM2工具类
 */
exports.PM2 = {
    /**
     * 获取服务状态
     * @param serverName 服务名称
     */
    getServerStatusWithPM2(serverName) {
        return new Promise(resolve => {
            pm2_1.default.connect(err => {
                if (err) {
                    resolve({ exists: false, online: false });
                    return;
                }
                const pm2Any = pm2_1.default;
                pm2Any.describe(serverName, (err, list) => {
                    pm2_1.default.disconnect();
                    if (err || !list || list.length === 0) {
                        resolve({ exists: false, online: false });
                        return;
                    }
                    const target = list[0];
                    resolve({
                        exists: true,
                        online: Boolean(target && target.pm2_env && target.pm2_env.status === 'online'),
                    });
                });
            });
        });
    },
    /**
     * 通过内置 PM2 编程 API 通用启动或重启后台服务（支持配置热更新）
     * @param options PM2 服务启动配置项
     * @returns 是否启动成功
     */
    async startServiceWithPm2(options) {
        const loadingText = `${options.name} 服务启动中...`;
        const successText = `${options.name} 服务已通过 PM2 在后台成功启动`;
        console.info(loadingText);
        return new Promise(resolve => {
            pm2_1.default.connect((err) => {
                if (err) {
                    console.error('PM2 连接失败:\n' + err);
                    resolve(false);
                    return;
                }
                const pm2Any = pm2_1.default;
                pm2Any.describe(options.name, (err, list) => {
                    const isExist = !err && list && list.length > 0;
                    const pm2Options = {
                        script: options.script,
                        name: options.name,
                        autorestart: true,
                    };
                    if (options.args)
                        pm2Options.args = options.args;
                    if (options.cwd)
                        pm2Options.cwd = options.cwd;
                    if (options.env)
                        pm2Options.env = options.env;
                    if (options.outputFile)
                        pm2Options.output = options.outputFile;
                    if (options.errorFile)
                        pm2Options.error = options.errorFile;
                    const handleResult = (actionErr) => {
                        pm2_1.default.disconnect();
                        if (actionErr) {
                            console.error(`${options.name} 服务启动失败:\n` + actionErr);
                            resolve(false);
                        }
                        else {
                            console.info(successText);
                            resolve(true);
                        }
                    };
                    if (isExist) {
                        // 如果服务已存在，先安全删除旧实例，再以最新配置重新 start，确保 env、日志路径等更新生效
                        pm2Any.delete(options.name, () => {
                            pm2Any.start(pm2Options, handleResult);
                        });
                    }
                    else {
                        // 不存在则直接新建并托管
                        pm2Any.start(pm2Options, handleResult);
                    }
                });
            });
        });
    },
    /**
     * 从 PM2 中卸载指定服务
     * @param serverName 服务名称
     */
    removeServerWithPM2(serverName) {
        return new Promise(resolve => {
            pm2_1.default.connect(err => {
                if (err) {
                    resolve(false);
                    return;
                }
                const pm2Any = pm2_1.default;
                pm2Any.delete(serverName, (err) => {
                    pm2_1.default.disconnect();
                    if (err) {
                        resolve(false);
                        return;
                    }
                    pm2Any.save?.(() => { });
                    resolve(true);
                });
            });
        });
    },
};
exports.default = exports.PM2;
